<main>
    <section class="flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">Usuarios</h1>
        <add-button label="Nuevo usuario" (onClick)="openEditForm()"></add-button>
    </section>

    <sau-table #sauTable [url]="url" contentList="users" contentTotal="total" [sizeInitialPage]="1"
        pageParamName="page" limitParamName="limit" [headers]="headers"
        (editEvent)="openEditForm($event)" (deleteEvent)="openDeleteForm($event)"></sau-table>
</main>
